<template>
  <div>
    <img class="chart" src="https://beame.oss-cn-hongkong.aliyuncs.com/appletsPic/top1.jpg" alt="" />
    <el-form
      class="content"
      ref="refForm"
      :rules="rules"
      :model="passwordResetForm"
    >
      <el-form-item prop="phone">
        <el-input
          class="phone"
          size="small"
          type="tel"
          maxlength="16"
          clearable
          v-model="passwordResetForm.phone"
          placeholder="输入手机号码"
        ></el-input>
      </el-form-item>
      <el-form-item prop="checkCode" class="checkCode">
        <el-input
          class="Code"
          size="small"
          clearable
          v-model="passwordResetForm.checkCode"
          placeholder="输入验证码"
        ></el-input>
        <el-button
          @click.stop="sendVerificationCode"
          size="mini"
          type="primary"
          style="margin-left: 10px"
          v-if="show"
          >发送验证码</el-button
        >
        <el-button
          size="mini"
          type="primary"
          style="margin-left: 10px"
          v-if="!show"
          disabled
          >{{ count }}秒后重发</el-button
        >
      </el-form-item>
      <div class="sign">
        <el-button @click.stop="sign" class="appointment">领取矫正礼包</el-button>
      </div>
    </el-form>
    <img class="chart" src="https://beame.oss-cn-hongkong.aliyuncs.com/appletsPic/bottom1.jpg" alt="" />
  </div>
</template>
<script>
import { getVerification } from "@/api/outpatient";

export default {
  data() {
    return {
      passwordResetForm: {
        phone: "",
        checkCode: "",
      },
      rules: {
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              let passwordreg =
                /^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[35678]|9[1389])\d{1}))\d{7}$/;
              if (!passwordreg.test(value)) {
                callback(new Error("请输入正确手机号"));
              } else {
                callback();
              }
            },
          },
        ],
        checkCode: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
          { min: 4, max: 4, message: "验证码为4位数字", trigger: "blur" },
        ],
      },
      show: true,
      count: "",
      timer: null,
      Code: null,
    };
  },
  mounted() {
    
  },
  methods: {
    //验证码 倒计时
    sendVerificationCode() {
      // 随机出验证码
      // var codeLength = 6;
      // var createPhoneCode = "";
      // // foreach循环，六次
      // for (var i = 0; i < codeLength; i++) {
      //   var index = Math.floor(Math.random() * 9);
      //   index = index.toString();
      //   createPhoneCode += index;
      // }
      // console.log(createPhoneCode);
      if (/^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[35678]|9[1389])\d{1}))\d{7}$/.test(this.passwordResetForm.phone) == false) {
        this.$message({
          message: "手機號格式不正確",
          type: "warning",
        });
        return;
      }
      localStorage.setItem("phone", JSON.stringify(this.passwordResetForm.phone));

      var uresData = {
        phone: this.passwordResetForm.phone,
        // checkCode: this.passwordResetForm.checkCode,
        language: "1",
      };
      getVerification(uresData).then((res) => {
        this.Code = res.data;
      });

      // 倒计时
      let TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
        // this.getCode();
      }
    },
    //验证码
    // getCode() {
    //   axios.get("/verificationCode.json").then((res) => {
    //     if (res.status == 200) {
    //       setTimeout(() => {
    //         this.passwordResetForm.checkCode = res.data.code;
    //         this.show = true;
    //         clearInterval(this.timer);
    //         this.timer = null;
    //       }, 3000);
    //     }
    //   });
    // },
    //登录
    sign() {
      if (this.passwordResetForm.phone == "") {
        this.$message({
          message: "手机号码不能为空",
          type: "warning",
        });
        return;
      }
      
      if (this.passwordResetForm.checkCode != this.Code) {
        this.$message({
          message: "验证码不正确",
          type: "warning",
        });
        return;
      }
      this.$router.push("/embed/about");
    },
  },
};
</script>

<style scoped>
.content {
  padding: 22px 30px;
}
.checkCode ::v-deep .el-form-item__content {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid rgba(214, 214, 214, 1);
}
::v-deep .el-form-item__label {
  font-weight: bold;
  padding: 0 0 0 0;
  text-align: left;
}
.sign > button {
  width: 100%;
  font-size: 18px;
  margin: 10px 0 20px 0;
}
.left {
  width: 10px;
  font-size: 40px;
  font-weight: bold;
  color: #fff;
  position: absolute;
  top: 50%;
  left: 25%;
  transform: translate(-50%, -50%);
}
.right {
  width: 10px;
  font-size: 40px;
  font-weight: bold;
  color: #fff;
  position: absolute;
  top: 50%;
  left: 75%;
  transform: translate(-50%, -50%);
}
.el-form >>> .el-input__inner {
  border-top: none;
  border-left: none;
  border-right: none;
}
.el-form >>> .phone .el-input__inner {
  background: url(../../img/shouji.png) no-repeat 0px center;
  background-size: 28px 28px;
  padding: 0px 40px; /*输入内容左右边距控制*/
  color: #000;
}
.el-form >>> .Code .el-input__inner {
  background: url(../../img/yzm.png) no-repeat 0px center;
  background-size: 28px 28px;
  padding: 0px 40px; /*输入内容左右边距控制*/
  color: #000;
  border: none;
}
.chart {
  width: 100%;
}
.el-button--primary {
  color: rgba(7, 171, 81, 1);
  background-color: #fff;
  border: none;
}
.appointment {
  border-radius: 191px;
  background: rgba(50, 62, 72, 1);
  color: rgba(0, 228, 103, 1);
}
.el-input>>>.el-input__inner{
    padding-left: 40px !important;
}
.el-form-item>>>.el-form-item__content{
  border-bottom: 1px solid rgba(214, 214, 214, 1);
}
</style>
